import React, {useCallback} from 'react';
import Documented from 'components/help/Documented.js';
import { connect } from "react-redux";

function CheckboxParameter(props) {

    const onChange = useCallback((e) => {
        document.activeElement.blur()
        props.parameter.set(!props.value);
    }, [props.parameter, props.value]);

    return (
        <Documented
          element={props.parameter}
          className="checkbox-parameter">
          <label>
            <input 
              type="checkbox"
              value="checked"
              checked={props.flipped ? !props.value : props.value}
              onChange={onChange}
            />
              {props.name}
          </label>
        </Documented>
    );
}

const mapStateToProps = (state, props) => {
    return {
        value: props.parameter.get() //state.effects.effectParameters[props.parameter.id]
    }
};
 
export default connect(mapStateToProps, null)(CheckboxParameter);


